// extracted by mini-css-extract-plugin
export default {"container":"CrediCardNotificationtCard_container__HvBIj","btn":"CrediCardNotificationtCard_btn__nzgCQ"};